import FilterTypePlacement from './FilterTypePlacement';

export default FilterTypePlacement;
